// @ts-nocheck
/* eslint-enable */
import React, { Component } from 'react';
import Container from 'app/shared/core/Container';
import 'app/shared/modules/mobile-apps/MoreInfoSection.scss';
import Text from 'app/shared/core/Text';

class MoreInfoSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          li: 'Display results on a map or in a list.',
        },
        {
          li: 'Scroll through high resolution photos.',
        },
        {
          li: 'See details: photos, price comparisons, floor plans, and more.',
        },
        {
          li: 'Track your housing search on all your devices with cross platform syncing.',
        },
        {
          li: 'Share saved and favorite properties with friends.',
        },
        {
          li: 'Call and inquire about properties right from your phone.',
        },
      ],

      quotes: [
        {
          source: 'CNET',
          p: '5 Android Apps for Mobile Apartment Searching',
        },
        {
          source: 'IntoMobile',
          p: 'Best Apps for Living on Your Own',
        },
        {
          source: 'Mashable',
          p: 'Beyond Craigslist: Sites for Apartment Hunters',
        },
      ],
    };
  }

  render() {
    return (
      <section className="MoreInfoSection" id="MoreInfoSection">
        <Container>
          <div className="MoreInfoSection-details">
            <Text htmlTag="h3" size="lg">
              <strong>You can also:</strong>
            </Text>
            <ul>
              {this.state.items.map((item, i) => {
                return <li key={i}>{item.li}</li>;
              }, this)}
            </ul>
          </div>
        </Container>
        <Container>
          <div className="MoreInfoSection-reviews">
            {this.state.quotes.map((quote, i) => {
              return (
                <p key={i}>
                  "{quote.p}" -{quote.source}
                </p>
              );
            }, this)}
          </div>
        </Container>
      </section>
    );
  }
}

export default MoreInfoSection;
